import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class ItemPricingExportQueryCriteriaClass extends BaseCriteriaModel {
    
    pricing_scheme_hdr_guids?: Optional<string[]> = Optional.empty();
    fi_item_hdr_guids?: Optional<string[]> = Optional.empty();
    fi_item_label_hdr_1_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_2_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_3_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_4_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_5_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_6_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_7_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_8_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_9_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_10_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_11_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_12_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_13_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_14_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_15_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_16_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_17_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_18_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_19_guids? : Optional<string[]> = Optional.empty();
    fi_item_label_hdr_20_guids? : Optional<string[]> = Optional.empty();
    fi_item_hdr_statuses? : Optional<string[]> = Optional.empty();
    label_hdr_guids? : Optional<string[]> = Optional.empty();
    
}